import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaColorInput from './VaColorInput.vue'

export const VaColorInput = withConfigTransport(_VaColorInput)
